import { TestProps } from "../../../types";
import { AtButtonSize, AtTagProps } from "../../atoms";
import { MlTableMessageProps } from "../../molecules";

export enum TableCellType {
  TEXT = "text",
  BUTTON = "button",
  BADGE = "badge",
  ORIGIN = "origin",
}
export interface BaseTableCell {
  type: TableCellType;
  className?: string;
  align?: "left" | "center" | "right";
  maxWidth?: string;
}
export interface TextCell extends BaseTableCell {
  type: TableCellType.TEXT;
  value: string;
}
export interface ButtonCell extends BaseTableCell {
  type: TableCellType.BUTTON;
  value: string;
  size?: AtButtonSize;
  onClick: () => void;
  disabled?: boolean;
}
export interface BadgeCell extends BaseTableCell {
  type: TableCellType.BADGE;
  tagProps: AtTagProps;
}
export interface OriginCell extends BaseTableCell {
  type: TableCellType.ORIGIN;
  origin: {
    type: "connect" | "advisor";
    name: string;
  };
}

export type TableCell = TextCell | ButtonCell | BadgeCell | OriginCell;

export interface TableRow {
  id: string;
  cells: TableCell[];
  onClick?: () => void;
  className?: string;
}

export enum TableType {
  CLIENTS = "clients",
  FOLIOS = "folios",
  FOLIOS_MINI = "folios-mini",
  AGENTS = "agents",
  ORDERS = "orders",
  ACTIVITY = "activity",
}

export interface OrTableProps extends TestProps {
  tableType: TableType;
  data: TableRow[];
  page: number;
  rowsPerPage: number;
  totalRows: number;
  loading?: boolean;
  className?: string;

  searchParams?: Record<string, unknown> | undefined;
  emptyStateConfig?: MlTableMessageProps;
  noResultsConfig?: MlTableMessageProps;
  onPageChange?: (page: number) => void;
  onRowClick?: (row: TableRow) => void;
  isMini?: boolean;
}

export interface TableConfig {
  type: TableType;
  headers: {
    header: string;
    maxWidth?: string;
  }[];
  sortable?: boolean;
  rowsPerPage?: number;
}
